import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { NotificationSMSAction } from '../../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../../pipes/highlight-variables.pipe';

@Component({
  selector: 'app-notification-sms-action',
  imports: [
    MatDivider,
    MatIcon,
    CdkDragHandle,
    NgTemplateOutlet,
    HighlightVariablesPipe,
  ],
  templateUrl: './notification-sms-action.component.html',
  styleUrl: './notification-sms-action.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSmsActionComponent {
  public readonly data = input.required<NotificationSMSAction>();
  public readonly actions = input<TemplateRef<unknown>>();
}
